module.exports = __webpack_public_path__ + "static/media/Baseball.1cb1e40a.jpg";